import { getAuthoredOverview, renderAuthoredNarrativeBundle } from './authoredNarrativeRender';
import { buildEvChargingNarrativeTokens } from './evChargingNarrativeTokens';

export type EvChargingViewId = 'counts' | 'peoplePerCharger' | 'evsPerCharger' | 'map';

export interface EvChargingNarrativeSnapshot {
  locationName: string;
  countyName: string;
  viewId: EvChargingViewId;
  totalChargers: number;
  l2Chargers: number;
  dcFastChargers: number;
  snapshotYear?: number;
  peoplePerCharger?: { city: number; county?: number; state: number | null };
  evsPerCharger?: { city: number; county?: number; state: number | null };
  target2030?: number | null;
  percentile?: number;
  stateFleetAvailable?: boolean;
  mapTractMedianChargers?: number | null;
  mapTractCount?: number | null;
}

const CHART_ID = 'ev_charging';

export function buildEvChargingAuthoredBundle(s: EvChargingNarrativeSnapshot) {
  const tokens = buildEvChargingNarrativeTokens(s);
  return renderAuthoredNarrativeBundle(CHART_ID, s.viewId, tokens);
}

export function buildEvChargingKeyInsights(s: EvChargingNarrativeSnapshot): string {
  const bundle = buildEvChargingAuthoredBundle(s);
  if (bundle.keyInsights) return bundle.keyInsights;
  return `Charging infrastructure data are not available for ${s.locationName}.`;
}

export function evChargingOverviewDescription(viewId: EvChargingViewId): string {
  return getAuthoredOverview(CHART_ID, viewId, 'EV charging infrastructure metrics.');
}
